module.exports = __webpack_public_path__ + "static/media/IconANTInactive.92b74157.svg";